<template>
  <div class="epic-integration">
    <header class="header">
      <h1>Epic Integration</h1>
    </header>
    <main class="content">
      <section class="intro">
        
      </section>
    </main>
  </div>
</template>

<script>
import { mapActions } from 'vuex/dist/vuex.common.js';

export default {
  name: 'EpicIntegration',
  data() {
    return {
    }
  },
  methods: {
    ...mapActions(['epicAuditLog'])
  },
  mounted() {
    this.epicAuditLog();
  }
}
</script>

<style scoped>
.epic-integration {
  padding: 20px;
}

.header {
  margin-bottom: 30px;
}

.header h1 {
  font-size: 2rem;
  margin: 0;
}

.content {
  max-width: 1200px;
}

.intro {
  margin-bottom: 20px;
}
</style>